import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { DailyExpenseRoute } from "../../types/daily-expense.type";
import { numberWithCommas } from "../../utils";
import OtherExpenseRow, { OTHER_ROW_COLUMNS } from "./OtherExpenseRow";
import { OtherRow, OtherRowErrors } from "./dailyExpenseForm";

interface OtherExpenseRowsProps {
  rows: OtherRow[];
  /** Row id → what is wrong; empty until the user tries to save. */
  errors: Record<number, OtherRowErrors>;
  routes: DailyExpenseRoute[];
  readOnly: boolean;
  onAdd: () => void;
  onChange: (id: number, patch: Partial<OtherRow>) => void;
  onBlurAmount: (id: number) => void;
  onRemove: (id: number) => void;
}

/** ส่วนที่ 3 · อื่นๆ: as many lines as the branch needs, each with its own group and description. */
export default function OtherExpenseRows({
  rows,
  errors,
  routes,
  readOnly,
  onAdd,
  onChange,
  onBlurAmount,
  onRemove,
}: Readonly<OtherExpenseRowsProps>) {
  return (
    <Paper>
      <Stack direction="row" justifyContent="space-between" alignItems="center" gap={1.25} mb={1.5}>
        <Stack direction="row" alignItems="baseline" gap={1.25}>
          <Typography fontWeight={600}>3 · อื่นๆ</Typography>
          <Typography variant="body2" color="text.secondary">
            {numberWithCommas(rows.length)} รายการ
          </Typography>
        </Stack>
        {!readOnly && (
          <Button variant="outlined" onClick={onAdd}>
            + เพิ่มรายการ
          </Button>
        )}
      </Stack>
      {rows.length === 0 ? (
        <Box
          sx={{
            p: 1.5,
            textAlign: "center",
            color: "text.secondary",
            border: 1,
            borderStyle: "dashed",
            borderColor: "divider",
            borderRadius: 2,
          }}
        >
          <Typography variant="body2">ไม่มีรายการอื่นๆ</Typography>
        </Box>
      ) : (
        <Stack gap={1.25}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: OTHER_ROW_COLUMNS,
              gap: 1.5,
              color: "text.secondary",
              typography: "body2",
              fontWeight: 500,
            }}
          >
            <span>กลุ่ม</span>
            <span>สาย</span>
            <span>คำอธิบาย</span>
            <Box component="span" sx={{ textAlign: "right" }}>
              จำนวนเงิน
            </Box>
          </Box>
          {rows.map((row) => (
            <OtherExpenseRow
              key={row.id}
              row={row}
              errors={errors[row.id] ?? null}
              routes={routes}
              readOnly={readOnly}
              onChange={onChange}
              onBlurAmount={onBlurAmount}
              onRemove={onRemove}
            />
          ))}
        </Stack>
      )}
    </Paper>
  );
}
